import React, { useState, useEffect } from 'react';

import Field from '../layout/Field.jsx';
import ContentContainer from '../layout/ContentContainer.jsx';
import SectionContainer from '../layout/SectionContainer.jsx';
import SectionNav from '../layout/SectionNav.jsx';

const colors = {
	A: '#00CE7B',
	B: '#FFDE2F',
	C: '#FF932F',
	D: '#FF2F2F',
};

const EvaluationResult = ({score}) => {
	return (<div 
		style={{display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontSize: 60, flexDirection: 'column'}}
	>
		<div style={{fontSize: 20, marginBottom: 12}}>
		Risk level:
		</div>
		<div style={{backgroundColor: colors[score], paddingLeft: 24, paddingRight: 24, paddingTop: 4, paddingBottom: 4, borderRadius: 12}}>
			{score}
		</div>
	</div>);
};

const EvaluationSection = ({
	Registry,
	fields = [],
	navigationProps,
	maxScore: passedMaxScore,
	onChange,
	name = 'evaluation',
	disabled = false,
}) => {
	const [testValues, setTestValues] = useState({});
	const [score, setScore] = useState();
	const [screen, setScreen] = useState('evaluation');

	useEffect(() => {
		setScreen('evaluation');
		setTestValues({});
	}, [fields]);
	
	const handleChange = ({ target }) => {
		const value = { ...testValues, [target.name]: target.value };
		setTestValues(value);
		onChange({target: {
			name,
			value,
		}});
	};
	
	const handleEvaluation = () => {
		setScreen('result');

		const totalAchievedScore = Object.values(testValues).reduce((cur, acc) => {
			return (typeof cur === 'string' ?  parseInt(cur): cur) + acc;
		}, 0);

		const maxScore = parseInt(passedMaxScore);

		const eventualScore = totalAchievedScore / maxScore;

		switch (true) {
		case eventualScore > 0.9: {
			onChange({ target: {
				name: 'evaluationScore',
				value: 'A',
			}});
			setScore('A');
			break;
		}
		case eventualScore > 0.8: {
			onChange({ target: {
				name: 'evaluationScore',
				value: 'B',
			}});
			setScore('B');
			break;
		}
		case eventualScore > 0.7: {
			onChange({ target: {
				name: 'evaluationScore',
				value: 'C',
			}});
			setScore('C');
			break;
		}
		default: {
			onChange({ target: {
				name: 'evaluationScore',
				value: 'D',
			}});
			setScore('D');
			break;
		}
		}
	};
  
	const next = screen === 'evaluation' ? handleEvaluation : navigationProps.next;
	const nextLabel = screen === 'evaluation' ? navigationProps.navigation.nextLabel : 'submit';
	const navigation = { ...navigationProps.navigation, nextLabel };

	return (
		<SectionContainer
			background='light'
			Navigation={<SectionNav {...navigationProps} 
				navigation={navigation} 
				hasNext={screen === 'evaluation' || navigationProps.hasNext} 
				next={next} 
			/>}
		>
			<ContentContainer>
				{screen === 'evaluation' ? fields.map((field, i) => 
					<Field 
						Registry={Registry} 
						key={field.name || i} 
						name={field.name} 
						{...field} 
						value={testValues[field.name]}
						disabled={disabled}
						onChange={handleChange}
					/>): <EvaluationResult score={score} />}
			</ContentContainer>
		</SectionContainer>
	);
};


EvaluationSection.type = 'EvaluationSection';
EvaluationSection.hasNavigation = true;
EvaluationSection.spec = [{
	name: 'EvaluationSection',
	key: 'EvaluationSection',
	title: 'Section to test evaluations',
	allowedFields: ['Typography', 'EvaluationCriteria'],
	fields: [{
		type: 'TextField',
		name: 'title',
		label: 'Test title',
	}, 
	{
		type: 'TextField',
		name: 'name',
		label: 'Test name',
	}, 
	{
		type: 'TextField',
		htmlType: 'number',
		name: 'maxScore',
		label: 'Maximum Score',
	}, 
	{
		type: 'TextField',
		name: 'navigation.previousLabel',
		label: 'Previous label',
		helperText: 'if there is a previous section, this will be the label to go back.',
	}, {
		type: 'TextField',
		name: 'navigation.nextLabel',
		label: 'Next label',
		helperText: 'if there is a next section, this will be the label to go forward.',
	}, {
		type: 'TextField',
		name: 'navigation.submitLabel',
		label: 'Submit label',
		helperText: 'If this section is the last section, this will be the text on the submit button.',
	}],
	defaultProperties: {
		title: 'Test title',
		navigation: {
			previousLabel: 'Previous',
			nextLabel: 'Next',
			submitLabel: 'Submit',
		},
	},
}];

export default EvaluationSection;